<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Download</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">File Download</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>

        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>

        <div *ngIf="!enableDisablePageLoader" class="file-download-content-container">
          <div class="file-download-card">
            <div class="section-title">Download Device File</div>
            <form [formGroup]="fileDownloadForm" (ngSubmit)="fileDownload()" novalidate>
              <div class="form-container row">
                <!-- Device Serial No -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>Device Serial No.</mat-label>
                    <mat-select formControlName="serial_number" (selectionChange)="emptyfilenamefilepath()">
                      <mat-option value="" disabled>Select Device Serial No.</mat-option>
                      <mat-option *ngFor="let dev of devices" [value]="dev.serial_number">{{ dev.serial_number }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="(fileDownloadFormValidation.serial_number.touched || submitted) && fileDownloadFormValidation.serial_number.hasError('required')">
                      <i>Device serial number is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- File Name -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>File Name</mat-label>
                    <input matInput formControlName="fileName" autocomplete="off" placeholder="Enter file name"/>
                    <mat-error *ngIf="(fileDownloadFormValidation.fileName.touched || submitted) && fileDownloadFormValidation.fileName.hasError('required')">
                      <i>File name is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- File Path -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>File Path</mat-label>
                    <input matInput formControlName="filePath" autocomplete="off" placeholder="Enter file path"/>
                    <mat-error *ngIf="(fileDownloadFormValidation.filePath.touched || submitted) && fileDownloadFormValidation.filePath.hasError('required')">
                      <i>File path is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Action Buttons -->
                <div class="col-xs-12 text-right action-btn-row">
                  <div class="buttons-div reports_search_div d-inline-block">
                    <div class="transactions-button-container">
                      <button type="submit" class="transaction-submit-button" [disabled]="submitting">
                        <span class="icon"><img src="assets/images/New_Icons/search-icon.svg" alt="Search icon"></span>
                        <span class="text">Display File Data</span>
                      </button>
                    </div>
                  </div>
                  <div class="buttons-div reports_search_div d-inline-block margin-left-10">
                    <div class="transactions-button-container">
                      <button type="button" class="transaction-submit-button download-btn" [disabled]="!disableDownload" (click)="downloadDeviceDatafile()">
                        <!-- <span class="icon"><img src="assets/images/New_Icons/download.svg" alt="Download icon"></span> -->
                        <span class="text">Download</span>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>

          <!-- Display Output Card -->
          <div *ngIf="dataAvail" class="file-download-card margin-top-20">
            <div class="section-title">File Data Output</div>
            <div class="fileuploadscroll">
              <p *ngFor="let line of disptextArr" class="code-line">{{ line }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--
  </div>
</div>-->
